import { connect } from 'react-redux';
import '@/styled/styled.default';
import type { Props } from '@/pages/CompanyReport/components/CompareCompanies';
import CompareCompany from '@/pages/CompanyReport/components/CompareCompanies';
import { makeCompanyListSelector } from '@/pages/CompanyReport/redux/selectors';
import { ROUTE_COMPARE_COMPANY, ROUTE_COMPARE_HOME } from '@/constants/routes';
import type { UiState } from '@ducks/ui';
import type { LocationState } from 'redux-first-router';

type StateProps = Omit<Props, 'handleReset' | 'handleSearch' | 'onRedirect'>;
const makeMapStateToProps = () => {
  const getCompanyList = makeCompanyListSelector();
  const mapStateToProps = (state): StateProps => {
    const { location }: { ui: UiState; location: LocationState } = state;
    const companies = getCompanyList(state, location.payload as any);

    return {
      companiesList: companies,
    };
  };
  return mapStateToProps;
};

type DispatchProps = Pick<Props, 'onRedirect'>;
const mapDispatchToProps = (dispatch): DispatchProps => {
  return {
    onRedirect: (symbols) =>
      dispatch(
        symbols === ''
          ? {
              type: ROUTE_COMPARE_HOME,
            }
          : {
              type: ROUTE_COMPARE_COMPANY,
              payload: {
                symbols: encodeURIComponent(symbols),
              },
            }
      ),
  };
};

export default connect(makeMapStateToProps, mapDispatchToProps)(CompareCompany);
